<template>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>Programa</label>
        <select-component
          name="programa"
          ref="programasSelect"
          @change="onChangePrograma"
          v-model="programa"
        >
          <option
            v-for="(programa, index) of programas"
            :key="index"
            :value="programa.programa_id"
          >{{ programa.nome_programa }}</option>
        </select-component>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Grupo de espécies</label>
        <select-component
          name="grupo"
          ref="gruposSelect"
          v-model="grupo"
        >
          <option v-if="grupos.length < 1" value>Selecione primeiro o programa</option>
          <option
            v-for="(grupo, index) of grupos"
            :key="index"
            :value="grupo.ids_especies"
          >{{ grupo.nome_grupo }}</option>
        </select-component>
        <input type="hidden" name="especiesIds" id="especiesIds" v-model="especiesIds"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    programa: {
      default: ""
    },
    grupo: {
      default: ""
    },
  },
  data: () => ({
    programa: "",
    grupo: "",
    especiesIds: "",
    programas: [],
    grupos: [],
  }),
  methods: {
    onChangePrograma(val) {
      this.programa = val;
      this.grupos = [];
      this.programa = val;
      if (val) {
        axios
          .get("/fiscalizacao/vigilancia-ativa-relatorios/get-grupos-de-especies", {
            params: {
              programa_id: val
            }
          })
          .then(res => res.data)
          .then(res => {
            this.grupos = res;
            console.log(this.$data.grupos);
            setTimeout(() => {
              this.$refs.gruposSelect.generateOptions();

              if (this.grupo) {
                this.grupo = this.grupo;
              }
            }, 0);
          });
      } else {
        setTimeout(() => {
          this.$refs.gruposSelect.generateOptions();
        }, 0);
      }
    }
  },
  beforeMount() {
    axios
      .get("/fiscalizacao/vigilancia-ativa-relatorios/get-programas")
      .then(res => res.data)
      .then(res => {
        this.programas = res;
        setTimeout(() => {
          this.$refs.programasSelect.generateOptions();

          if (this.programa) {
            this.onChangePrograma(this.programa);
          }
        }, 500);
      });
  }
};
</script>
